'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Star = function (_React$PureComponent) {
  _inherits(Star, _React$PureComponent);

  function Star() {
    _classCallCheck(this, Star);

    return _possibleConstructorReturn(this, (Star.__proto__ || Object.getPrototypeOf(Star)).apply(this, arguments));
  }

  _createClass(Star, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          size = _props.size,
          shadow = _props.shadow;

      return _react2.default.createElement(
        'svg',
        {
          width: size,
          height: size,
          viewBox: '0 0 19 19',
          version: '1.1',

          xmlnsXlink: 'http://www.w3.org/1999/xlink',
          className: 'jsx-486983455' + ' ' + ((shadow ? 'shadow' : '') || '')
        },
        _react2.default.createElement(
          'defs',
          {
            className: 'jsx-486983455'
          },
          _react2.default.createElement('path', { d: 'M19 7.363c0 .176-.099.367-.297.575l-4.145 4.238.982 5.986c.008.056.012.136.012.24 0 .398-.156.598-.468.598a.893.893 0 0 1-.457-.144L9.5 16.031l-5.127 2.825a.937.937 0 0 1-.457.144c-.16 0-.28-.058-.36-.174a.73.73 0 0 1-.12-.425c0-.048.009-.127.024-.24l.982-5.985L.285 7.938C.095 7.722 0 7.53 0 7.363c0-.295.213-.479.64-.55l5.731-.875L8.941.491C9.085.164 9.27 0 9.5 0c.228 0 .415.164.56.49l2.569 5.448 5.732.874c.426.072.639.256.639.55z', className: 'jsx-486983455'
          })
        ),
        _react2.default.createElement(
          'g',
          {
            transform: 'translate(0.000000, -1.000000) translate(0.000000, 1.000000)',
            stroke: 'none',
            strokeWidth: 1,
            fill: 'none',
            fillRule: 'evenodd',
            className: 'jsx-486983455'
          },
          _react2.default.createElement('path', {
            d: 'M19 7.363c0 .176-.099.367-.297.575l-4.145 4.238.982 5.986c.008.056.012.136.012.24 0 .398-.156.598-.468.598a.893.893 0 0 1-.457-.144L9.5 16.031l-5.127 2.825a.937.937 0 0 1-.457.144c-.16 0-.28-.058-.36-.174a.73.73 0 0 1-.12-.425c0-.048.009-.127.024-.24l.982-5.985L.285 7.938C.095 7.722 0 7.53 0 7.363c0-.295.213-.479.64-.55l5.731-.875L8.941.491C9.085.164 9.27 0 9.5 0c.228 0 .415.164.56.49l2.569 5.448 5.732.874c.426.072.639.256.639.55z',
            fill: color,
            className: 'jsx-486983455'
          })
        ),
        _react2.default.createElement(
          _style2.default,
          {
            id: '486983455'
          },
          ['.shadow.jsx-486983455{-webkit-filter:drop-shadow(0px 3px 1px rgba(0,0,0,0.3));filter:drop-shadow(0px 3px 1px rgba(0,0,0,0.3));}']
        )
      );
    }
  }]);

  return Star;
}(_react2.default.PureComponent);

Star.defaultProps = {
  color: '#FFFFFF',
  size: 64,
  shadow: false
};

Star.propTypes = {
  color: _propTypes2.default.string,
  shadow: _propTypes2.default.bool,
  size: _propTypes2.default.number
};

exports.default = Star;